export class RawString {
    constructor(val) {
        this.val = val;
    }
    /**
     * Returns the content of the RawString object as a simple string
     */
    toString() {
        return this.val;
    }
    toJSON() {
        return this.val;
    }
}
